import { render, staticRenderFns } from "./IconTrash.vue?vue&type=template&id=674f40ee&scoped=true&functional=true&"
import script from "./IconTrash.vue?vue&type=script&lang=ts&"
export * from "./IconTrash.vue?vue&type=script&lang=ts&"
import style0 from "./IconTrash.vue?vue&type=style&index=0&id=674f40ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "674f40ee",
  null
  
)

export default component.exports